import { isEmpty } from 'lodash';
import moment from 'moment';

function getAdminStatistics(adminStatsDat, adminStatsJson) {
  const statistics = {
    allUsers: 0,
    activeUsers: 0,
    usersWithAtLeastOneCommit: 0,
    datetimeOfFirstCommit: null,
    datetimeOfSecondCommit: null,
    datetimeOfLastCommit: null,
    averageCommitsPerUser: 0,
    averageCommitsPerMonth: 0,
    numberOfCommits: 0,
  };

  if (isEmpty(adminStatsDat) || isEmpty(adminStatsJson)) {
    return statistics;
  }

  statistics.allUsers = adminStatsJson.users_from_app.length;
  statistics.activeUsers = adminStatsJson.users_from_app.filter(user => user.is_active).length;
  statistics.usersWithAtLeastOneCommit = Object.values(adminStatsJson.authors).length;

  const sortedCommitDates = Object.values(adminStatsJson.dates).sort((a, b) => {
    return Date.parse(a) - Date.parse(b);
  });

  statistics.datetimeOfFirstCommit =
      sortedCommitDates.length > 0 ? new Date(sortedCommitDates[0]) : null;

  statistics.datetimeOfSecondCommit =
      sortedCommitDates.length > 1 ? new Date(sortedCommitDates[1]) : null;

  statistics.datetimeOfLastCommit =
      sortedCommitDates.length > 0 ? new Date(sortedCommitDates.slice(-1)[0]) : null;

  statistics.averageCommitsPerUser = statistics.activeUsers > 0 ?
      (parseFloat(adminStatsDat.length) / parseFloat(statistics.activeUsers)).toFixed(2) : 0;

  const currentDate = new Date();
  const monthsBetweenFirstCommitAndToday =
      moment(currentDate).diff(statistics.datetimeOfFirstCommit, 'months', true);
  statistics.averageCommitsPerMonth = monthsBetweenFirstCommitAndToday >= 1 ?
      (parseFloat(adminStatsDat.length) / parseFloat(monthsBetweenFirstCommitAndToday)).toFixed(2) : 0;

  statistics.numberOfCommits = adminStatsDat.length;

  return statistics;
}

function getAdminStatisticsWithTimePeriod(adminStatsDat, adminStatsJson, startDate, endDate) {
  const statistics = {
    numberOfCommits: 0,
  };

  if (isEmpty(adminStatsDat) || isEmpty(adminStatsJson)) {
    return statistics;
  }

  for (let i = 0; i < adminStatsDat.length; i += 1) {
    const [date, ,] = adminStatsDat[i];
    const dateM = moment(adminStatsJson.dates[date]);

    if (!startDate && !endDate) {
      statistics.numberOfCommits += 1;
    }
    else {
      const isBetween = dateM.isBetween(startDate, endDate, null, '[]');
      if (isBetween) {
        statistics.numberOfCommits += 1;
      }
    }
  }

  return statistics;
}

export default {
  getAdminStatistics,
  getAdminStatisticsWithTimePeriod,
};
